(() => {
  const root = document.querySelector('[data-praxis-check]');
  if (!root) return;

  const PASSWORD = root.dataset.password || 'marketing13';
  const STORAGE_KEY = root.dataset.storageKey || 'baerenwerke-praxis-check-v1';
  const UNLOCK_KEY = STORAGE_KEY + ':unlocked';
  const PENDING_KEY = STORAGE_KEY + ':pending-submit';
  const FILES_DB = STORAGE_KEY + '-files';
  const FILES_STORE = 'files';
  const MAX_FILE_BYTES = 5 * 1024 * 1024;
  const MAX_SUBMIT_BYTES = 9 * 1024 * 1024;
  const WORKER_URL = (root.dataset.workerUrl || 'https://aged-rain-e50c.gibsor13.workers.dev').trim().replace(/\/$/, '');
  const SUBMIT_SECRET = (root.dataset.submitSecret || '').trim();

  const els = {
    gate: root.querySelector('[data-pc-gate]'),
    app: root.querySelector('[data-pc-app]'),
    success: root.querySelector('[data-pc-success]'),
    passwordForm: root.querySelector('[data-pc-password-form]'),
    passwordInput: root.querySelector('#pc-password'),
    gateStatus: root.querySelector('[data-pc-gate-status]'),
    progressBar: root.querySelector('[data-pc-progress-bar]'),
    progressLabel: root.querySelector('[data-pc-progress-label]'),
    stepNav: root.querySelector('[data-pc-step-nav]'),
    panels: [...root.querySelectorAll('[data-pc-panel]')],
    form: root.querySelector('[data-pc-form]'),
    prevBtn: root.querySelector('[data-pc-prev]'),
    nextBtn: root.querySelector('[data-pc-next]'),
    submitBtn: root.querySelector('[data-pc-submit]'),
    lightbox: root.querySelector('[data-pc-lightbox]'),
    lightboxImg: root.querySelector('[data-pc-lightbox-img]'),
    lightboxClose: root.querySelector('[data-pc-lightbox-close]'),
    toast: root.querySelector('[data-pc-toast]'),
    toastMsg: root.querySelector('[data-pc-toast-msg]'),
    toastClose: root.querySelector('[data-pc-toast-close]'),
  };

  const STEP_IDS = ['intro', 'task1', 'task2a', 'task2b', 'task3', 'task4', 'task5'];
  const STEP_LABELS = [
    '1 Daten',
    '2 Ads',
    '3 Startseite',
    '4 Produktseite',
    '5 Medien',
    '6 Inspiration',
    '7 Aktionen',
  ];

  /** @type {Map<string, {id:string,file:File,url:string}[]>} */
  const uploads = new Map();
  /** @type {Record<string, number>} */
  const answerSeq = { task2a: 0, task2b: 0 };
  let stepIndex = 0;
  let submitting = false;

  function escapeAttr(value) {
    return String(value || '')
      .replace(/&/g, '&amp;')
      .replace(/"/g, '&quot;')
      .replace(/</g, '&lt;');
  }

  function uploadsMarkup(uploadId) {
    return `
      <div class="praxis-check__uploads" data-pc-uploads="${escapeAttr(uploadId)}">
        <div class="praxis-check__uploads-head">
          <span class="praxis-check__label">Bilder hinzufügen (optional)</span>
          <label class="praxis-check__upload-btn">
            Dateien wählen
            <input
              class="visually-hidden"
              type="file"
              accept="image/*"
              multiple
              data-pc-file-input
              data-upload-id="${escapeAttr(uploadId)}"
            >
          </label>
        </div>
        <p class="praxis-check__hint">Optional – Screenshots/Beispiele, max. 5&nbsp;MB pro Bild.</p>
        <div class="praxis-check__upload-previews" data-pc-file-previews></div>
      </div>`;
  }

  function getAnswerList(prefix) {
    return root.querySelector(`[data-pc-answer-list="${prefix}"]`);
  }

  function getAnswerBlocks(prefix) {
    const list = getAnswerList(prefix);
    return list ? [...list.querySelectorAll('[data-pc-answer-block]')] : [];
  }

  function renumberAnswerBlocks(prefix) {
    getAnswerBlocks(prefix).forEach((block, i) => {
      const title = block.querySelector('[data-pc-answer-title]');
      if (title) title.textContent = `Verbesserung ${i + 1}`;
      const removeBtn = block.querySelector('[data-pc-remove-answer]');
      if (removeBtn) removeBtn.hidden = getAnswerBlocks(prefix).length <= 1;
    });
  }

  function clearUploadGroup(uploadId) {
    const list = getUploadList(uploadId);
    list.forEach((item) => URL.revokeObjectURL(item.url));
    uploads.delete(uploadId);
  }

  function createAnswerBlock(prefix, blockId, text) {
    const id = blockId || String(++answerSeq[prefix]);
    if (Number(id) > answerSeq[prefix]) answerSeq[prefix] = Number(id);
    const uploadId = `${prefix}_${id}`;
    const wrap = document.createElement('div');
    wrap.className = 'praxis-check__subcard praxis-check__answer-block';
    wrap.setAttribute('data-pc-answer-block', '');
    wrap.setAttribute('data-block-id', id);
    wrap.innerHTML = `
      <div class="praxis-check__answer-head">
        <h3 class="praxis-check__subcard-title" data-pc-answer-title>Verbesserung</h3>
        <button type="button" class="praxis-check__answer-remove" data-pc-remove-answer aria-label="Verbesserung entfernen">Entfernen</button>
      </div>
      <div class="praxis-check__field">
        <label class="praxis-check__label" for="${escapeAttr(prefix)}_text_${escapeAttr(id)}">Beschreibung</label>
        <textarea
          class="praxis-check__textarea praxis-check__textarea--lg"
          id="${escapeAttr(prefix)}_text_${escapeAttr(id)}"
          name="${escapeAttr(prefix)}_text_${escapeAttr(id)}"
          rows="6"
          data-pc-answer-text
        ></textarea>
      </div>
      ${uploadsMarkup(uploadId)}
    `;
    const ta = wrap.querySelector('[data-pc-answer-text]');
    if (ta) ta.value = text || '';
    return wrap;
  }

  function ensureAnswerList(prefix, entries) {
    const list = getAnswerList(prefix);
    if (!list) return;
    const host = list.querySelector('[data-pc-answer-blocks]');
    if (!host) return;
    host.innerHTML = '';
    answerSeq[prefix] = 0;
    const items = Array.isArray(entries) && entries.length ? entries : [{ id: null, text: '' }];
    items.forEach((entry) => {
      const block = createAnswerBlock(prefix, entry && entry.id, entry && entry.text);
      host.appendChild(block);
    });
    renumberAnswerBlocks(prefix);
  }

  function collectAnswerList(prefix) {
    return getAnswerBlocks(prefix).map((block) => {
      const id = block.getAttribute('data-block-id') || '';
      const textEl = block.querySelector('[data-pc-answer-text]');
      return {
        id,
        text: (textEl && textEl.value.trim()) || '',
        uploadId: `${prefix}_${id}`,
      };
    });
  }

  function addAnswerBlock(prefix) {
    const list = getAnswerList(prefix);
    const host = list && list.querySelector('[data-pc-answer-blocks]');
    if (!host) return;
    host.appendChild(createAnswerBlock(prefix));
    renumberAnswerBlocks(prefix);
    persistForm();
  }

  function removeAnswerBlock(block) {
    const list = block.closest('[data-pc-answer-list]');
    if (!list) return;
    const prefix = list.getAttribute('data-pc-answer-list');
    const blocks = getAnswerBlocks(prefix);
    if (blocks.length <= 1) {
      const textEl = block.querySelector('[data-pc-answer-text]');
      if (textEl) textEl.value = '';
      const id = block.getAttribute('data-block-id');
      if (id) clearUploadGroup(`${prefix}_${id}`);
      renderUploads(`${prefix}_${id}`);
      persistForm();
      return;
    }
    const id = block.getAttribute('data-block-id');
    if (id) clearUploadGroup(`${prefix}_${id}`);
    block.remove();
    renumberAnswerBlocks(prefix);
    persistForm();
  }

  function showToast(message) {
    if (!els.toast || !els.toastMsg) return;
    els.toastMsg.textContent = message;
    els.toast.hidden = false;
  }

  function hideToast() {
    if (!els.toast) return;
    els.toast.hidden = true;
    if (els.toastMsg) els.toastMsg.textContent = '';
  }

  function loadDraft() {
    try {
      const raw = localStorage.getItem(STORAGE_KEY);
      return raw ? JSON.parse(raw) : null;
    } catch {
      return null;
    }
  }

  function saveDraft(partial) {
    const current = loadDraft() || {};
    const next = Object.assign({}, current, partial, { updatedAt: Date.now() });
    try {
      localStorage.setItem(STORAGE_KEY, JSON.stringify(next));
    } catch {
      /* ignore */
    }
  }

  function clearDraft() {
    try {
      localStorage.removeItem(STORAGE_KEY);
      sessionStorage.removeItem(UNLOCK_KEY);
    } catch {
      /* ignore */
    }
    clearStoredFiles();
  }

  function openFilesDb() {
    return new Promise((resolve, reject) => {
      const req = indexedDB.open(FILES_DB, 1);
      req.onupgradeneeded = () => {
        const db = req.result;
        if (!db.objectStoreNames.contains(FILES_STORE)) {
          db.createObjectStore(FILES_STORE, { keyPath: 'key' });
        }
      };
      req.onsuccess = () => resolve(req.result);
      req.onerror = () => reject(req.error || new Error('IndexedDB Fehler'));
    });
  }

  async function persistUploads() {
    try {
      const db = await openFilesDb();
      const records = [];
      uploads.forEach((list, uploadId) => {
        list.forEach((item) => {
          records.push({
            key: `${uploadId}::${item.id}`,
            uploadId,
            fileId: item.id,
            name: item.file.name,
            type: item.file.type,
            lastModified: item.file.lastModified || Date.now(),
            blob: item.file,
          });
        });
      });

      await new Promise((resolve, reject) => {
        const tx = db.transaction(FILES_STORE, 'readwrite');
        const store = tx.objectStore(FILES_STORE);
        const clearReq = store.clear();
        clearReq.onerror = () => reject(clearReq.error);
        clearReq.onsuccess = () => {
          records.forEach((record) => store.put(record));
        };
        tx.oncomplete = () => resolve();
        tx.onerror = () => reject(tx.error);
      });
      db.close();
    } catch {
      /* private mode / quota */
    }
  }

  async function restoreUploads() {
    try {
      const db = await openFilesDb();
      const records = await new Promise((resolve, reject) => {
        const tx = db.transaction(FILES_STORE, 'readonly');
        const req = tx.objectStore(FILES_STORE).getAll();
        req.onsuccess = () => resolve(req.result || []);
        req.onerror = () => reject(req.error);
      });
      db.close();

      uploads.clear();
      records.forEach((record) => {
        if (!record || !record.blob) return;
        const file = new File([record.blob], record.name || 'bild.jpg', {
          type: record.type || 'image/jpeg',
          lastModified: record.lastModified || Date.now(),
        });
        const list = getUploadList(record.uploadId);
        list.push({
          id: record.fileId,
          file,
          url: URL.createObjectURL(file),
        });
      });

      [...root.querySelectorAll('[data-pc-uploads]')].forEach((wrap) => {
        const id = wrap.getAttribute('data-pc-uploads');
        if (id) renderUploads(id);
      });
    } catch {
      /* ignore */
    }
  }

  async function clearStoredFiles() {
    try {
      const db = await openFilesDb();
      await new Promise((resolve, reject) => {
        const tx = db.transaction(FILES_STORE, 'readwrite');
        tx.objectStore(FILES_STORE).clear();
        tx.oncomplete = () => resolve();
        tx.onerror = () => reject(tx.error);
      });
      db.close();
    } catch {
      /* ignore */
    }
  }

  function collectAnswers() {
    const form = els.form;
    const get = (name) => ((form.querySelector(`[name="${name}"]`) || {}).value || '').trim();

    const images = [...form.querySelectorAll('[data-pc-image-block]')].map((block, i) => {
      const n = i + 1;
      return {
        id: block.dataset.imageId || '',
        label: block.dataset.imageLabel || `Bild ${n}`,
        aesthetics: get(`task3_${n}_aesthetics`) || '5',
        staging: get(`task3_${n}_staging`) || '5',
        comment: get(`task3_${n}_comment`),
      };
    });

    return {
      name: get('name'),
      email: get('email'),
      start_date: get('start_date'),
      task1_steps: get('task1_steps'),
      task1_profitability: get('task1_profitability'),
      task2a_answers: collectAnswerList('task2a'),
      task2b_product_url: get('task2b_product_url'),
      task2b_answers: collectAnswerList('task2b'),
      task3_images: images,
      task4_examples: [1, 2, 3].map((n) => ({
        url: get(`task4_${n}_url`),
        why: get(`task4_${n}_why`),
      })),
      task5_campaigns: get('task5_campaigns'),
    };
  }

  function applyAnswers(answers) {
    if (!answers || !els.form) return;
    const set = (name, value) => {
      const el = els.form.querySelector(`[name="${name}"]`);
      if (el) el.value = value || '';
    };
    set('name', answers.name);
    set('email', answers.email);
    set('start_date', answers.start_date);
    set('task1_steps', answers.task1_steps);
    set('task1_profitability', answers.task1_profitability);
    set('task2b_product_url', answers.task2b_product_url);
    set('task5_campaigns', answers.task5_campaigns);

    const task2aEntries =
      Array.isArray(answers.task2a_answers) && answers.task2a_answers.length
        ? answers.task2a_answers
        : answers.task2a_homepage
          ? [{ id: '1', text: answers.task2a_homepage }]
          : [{ id: '1', text: '' }];
    const task2bEntries =
      Array.isArray(answers.task2b_answers) && answers.task2b_answers.length
        ? answers.task2b_answers
        : answers.task2b_improvements
          ? [{ id: '1', text: answers.task2b_improvements }]
          : [{ id: '1', text: '' }];
    ensureAnswerList('task2a', task2aEntries);
    ensureAnswerList('task2b', task2bEntries);

    (answers.task3_images || []).forEach((img, i) => {
      const n = i + 1;
      set(`task3_${n}_aesthetics`, img.aesthetics || '5');
      set(`task3_${n}_staging`, img.staging || '5');
      set(`task3_${n}_comment`, img.comment || img.good || img.bad || img.improve || '');
    });

    (answers.task4_examples || []).forEach((ex, i) => {
      set(`task4_${i + 1}_url`, ex.url);
      set(`task4_${i + 1}_why`, ex.why);
    });

    syncSliderValues();
  }

  function syncSliderValues() {
    [...root.querySelectorAll('[data-pc-slider]')].forEach((slider) => {
      const valueEl = slider.closest('.praxis-check__slider-field')?.querySelector('[data-pc-slider-value]');
      if (valueEl) valueEl.textContent = slider.value || '5';
    });
  }

  function persistForm() {
    saveDraft({ stepIndex, answers: collectAnswers() });
  }

  function isValidHttpUrl(value) {
    try {
      const u = new URL(String(value || '').trim());
      return u.protocol === 'http:' || u.protocol === 'https:';
    } catch {
      return false;
    }
  }

  function setFieldInvalid(el, invalid) {
    if (!el) return;
    el.classList.toggle('is-invalid', !!invalid);
  }

  function validateStep(index) {
    const id = STEP_IDS[index];
    const answers = collectAnswers();
    let message = '';

    if (id === 'intro') {
      const nameEl = els.form.querySelector('[name="name"]');
      const emailEl = els.form.querySelector('[name="email"]');
      const startEl = els.form.querySelector('[name="start_date"]');
      const nameOk = !!answers.name;
      const emailOk = /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(answers.email);
      const startOk = !!answers.start_date;
      setFieldInvalid(nameEl, !nameOk);
      setFieldInvalid(emailEl, !emailOk);
      setFieldInvalid(startEl, !startOk);
      if (!nameOk) message = 'Bitte Vor- und Nachname angeben.';
      else if (!emailOk) message = 'Bitte eine gültige E-Mail-Adresse angeben.';
      else if (!startOk) message = 'Bitte frühestes Eintrittsdatum angeben.';
    }

    if (id === 'task1') {
      const el = els.form.querySelector('[name="task1_steps"]');
      const profitEl = els.form.querySelector('[name="task1_profitability"]');
      const ok = !!answers.task1_steps;
      const profitOk = !!answers.task1_profitability;
      setFieldInvalid(el, !ok);
      setFieldInvalid(profitEl, !profitOk);
      if (!ok) message = 'Bitte Aufgabe 2 beantworten.';
      else if (!profitOk) message = 'Bitte die Frage zu Performance & Profitabilität beantworten.';
    }

    if (id === 'task2a') {
      const blocks = getAnswerBlocks('task2a');
      const filled = (answers.task2a_answers || []).some((a) => a && a.text);
      blocks.forEach((block) => {
        const ta = block.querySelector('[data-pc-answer-text]');
        setFieldInvalid(ta, !filled);
      });
      if (!filled) message = 'Bitte mindestens eine Startseiten-Verbesserung ausfüllen.';
    }

    if (id === 'task2b') {
      const url = els.form.querySelector('[name="task2b_product_url"]');
      const urlOk = isValidHttpUrl(answers.task2b_product_url);
      const filled = (answers.task2b_answers || []).some((a) => a && a.text);
      setFieldInvalid(url, !urlOk);
      getAnswerBlocks('task2b').forEach((block) => {
        const ta = block.querySelector('[data-pc-answer-text]');
        setFieldInvalid(ta, !filled);
      });
      if (!urlOk) message = 'Bitte einen gültigen Produktseiten-Link angeben (https://…).';
      else if (!filled) message = 'Bitte mindestens eine Produktseiten-Verbesserung ausfüllen.';
    }

    // task3: alle Bildkommentare optional – Bewerber wählen selbst, was sie kommentieren

    if (id === 'task4') {
      for (let n = 1; n <= 3; n++) {
        const urlEl = els.form.querySelector(`[name="task4_${n}_url"]`);
        const whyEl = els.form.querySelector(`[name="task4_${n}_why"]`);
        const urlOk = isValidHttpUrl(urlEl && urlEl.value);
        setFieldInvalid(urlEl, !urlOk);
        setFieldInvalid(whyEl, false);
        if (!urlOk) {
          message = `Bitte bei Beispiel ${n} einen gültigen Link angeben.`;
          break;
        }
      }
    }

    if (id === 'task5') {
      const el = els.form.querySelector('[name="task5_campaigns"]');
      const ok = !!answers.task5_campaigns;
      setFieldInvalid(el, !ok);
      if (!ok) message = 'Bitte Aufgabe 7 beantworten.';
    }

    if (message) showToast(message);
    else hideToast();
    return !message;
  }

  function renderStepNav() {
    if (!els.stepNav) return;
    els.stepNav.innerHTML = STEP_LABELS.map((label, i) => {
      const active = i === stepIndex ? 'is-active' : '';
      const complete = i < stepIndex ? 'is-complete' : '';
      return `<li><button type="button" class="praxis-check__step-btn ${active} ${complete}" data-pc-goto="${i}">${escapeHtml(
        label
      )}</button></li>`;
    }).join('');
  }

  function escapeHtml(value) {
    return String(value || '')
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;');
  }

  function updateProgress() {
    const sectionRatio = (stepIndex + 1) / STEP_IDS.length;
    if (els.progressBar) els.progressBar.style.width = `${Math.round(sectionRatio * 100)}%`;
    if (els.progressLabel) {
      els.progressLabel.textContent = `Abschnitt ${stepIndex + 1} von ${STEP_IDS.length}`;
    }
    renderStepNav();
  }

  function showStep(index, { validateCurrent } = {}) {
    const nextIndex = Math.max(0, Math.min(index, STEP_IDS.length - 1));
    if (validateCurrent && nextIndex > stepIndex && !validateStep(stepIndex)) return;

    stepIndex = nextIndex;
    els.panels.forEach((panel) => {
      const match = panel.getAttribute('data-pc-panel') === STEP_IDS[stepIndex];
      panel.hidden = !match;
    });

    if (els.prevBtn) els.prevBtn.hidden = stepIndex === 0;
    if (els.nextBtn) els.nextBtn.hidden = stepIndex === STEP_IDS.length - 1;
    if (els.submitBtn) els.submitBtn.hidden = stepIndex !== STEP_IDS.length - 1;

    updateProgress();
    persistForm();
    root.scrollIntoView({ behavior: 'smooth', block: 'start' });
  }

  function getUploadList(id) {
    if (!uploads.has(id)) uploads.set(id, []);
    return uploads.get(id);
  }

  function renderUploads(id) {
    const wrap = root.querySelector(`[data-pc-uploads="${id}"]`);
    if (!wrap) return;
    const previews = wrap.querySelector('[data-pc-file-previews]');
    if (!previews) return;
    const list = getUploadList(id);
    previews.innerHTML = list
      .map(
        (item) => `
      <div class="praxis-check__upload-preview" data-file-id="${item.id}">
        <button type="button" class="praxis-check__upload-remove" data-pc-remove-file data-upload-id="${id}" data-file-id="${item.id}" aria-label="Entfernen">×</button>
        <img src="${item.url}" alt="">
        <span class="praxis-check__upload-preview-name">${item.file.name}</span>
      </div>`
      )
      .join('');
  }

  function addFiles(id, fileList) {
    const list = getUploadList(id);
    [...fileList].forEach((file) => {
      if (!file.type.startsWith('image/')) {
        showToast(`„${file.name}“ ist kein Bild.`);
        return;
      }
      if (file.size > MAX_FILE_BYTES) {
        showToast(`„${file.name}“ ist größer als 5 MB.`);
        return;
      }
      list.push({
        id: `${Date.now()}-${Math.random().toString(36).slice(2, 8)}`,
        file,
        url: URL.createObjectURL(file),
      });
    });
    renderUploads(id);
    persistUploads();
  }

  function removeFile(uploadId, fileId) {
    const list = getUploadList(uploadId);
    const idx = list.findIndex((item) => item.id === fileId);
    if (idx < 0) return;
    URL.revokeObjectURL(list[idx].url);
    list.splice(idx, 1);
    renderUploads(uploadId);
    persistUploads();
  }

  async function unlock() {
    try {
      sessionStorage.setItem(UNLOCK_KEY, '1');
    } catch {
      /* ignore */
    }
    els.gate.hidden = true;
    els.success.hidden = true;
    els.app.hidden = false;

    const draft = loadDraft() || {};
    applyAnswers(draft.answers || {});
    await restoreUploads();
    const savedStep = Number.isInteger(draft.stepIndex) ? draft.stepIndex : 0;
    showStep(savedStep);
  }

  function onPasswordSubmit(event) {
    event.preventDefault();
    const value = (els.passwordInput.value || '').trim();
    if (value !== PASSWORD) {
      showToast('Passwort ist falsch.');
      if (els.gateStatus) {
        els.gateStatus.textContent = '';
      }
      return;
    }
    hideToast();
    els.passwordInput.value = '';
    unlock();
  }

  function buildMessageBody(answers) {
    const lines = [];
    lines.push('PRAXIS-CHECK – E-Commerce & Performance Marketing Manager');
    lines.push(`Eingereicht: ${new Date().toLocaleString('de-DE')}`);
    lines.push('');
    lines.push(`Name: ${answers.name}`);
    lines.push(`E-Mail: ${answers.email}`);
    lines.push(
      `Frühestes Eintrittsdatum: ${
        answers.start_date
          ? new Date(`${answers.start_date}T00:00:00`).toLocaleDateString('de-DE')
          : '–'
      }`
    );
    lines.push('');
    lines.push('=== Aufgabe 2 – Performance Marketing ===');
    lines.push(answers.task1_steps || '–');
    lines.push('');
    lines.push('=== Performance & Profitabilität ===');
    lines.push(answers.task1_profitability || '–');
    lines.push('');
    lines.push('=== Aufgabe 3 – Startseite ===');
    (answers.task2a_answers || []).forEach((ans, i) => {
      lines.push(`Verbesserung ${i + 1} [${ans.uploadId || `task2a_${ans.id || i + 1}`}]:`);
      lines.push(ans.text || '–');
      lines.push('');
    });
    if (!(answers.task2a_answers || []).length) {
      lines.push(answers.task2a_homepage || '–');
      lines.push('');
    }
    lines.push('=== Aufgabe 4 – Produktseite ===');
    lines.push(`Link: ${answers.task2b_product_url || '–'}`);
    (answers.task2b_answers || []).forEach((ans, i) => {
      lines.push(`Verbesserung ${i + 1} [${ans.uploadId || `task2b_${ans.id || i + 1}`}]:`);
      lines.push(ans.text || '–');
      lines.push('');
    });
    if (!(answers.task2b_answers || []).length) {
      lines.push(answers.task2b_improvements || '–');
      lines.push('');
    }
    lines.push('=== Aufgabe 5 – Produktmedien ===');
    (answers.task3_images || []).forEach((img, i) => {
      lines.push(`Bild ${i + 1}: ${img.label || ''}`);
      lines.push(`Ästhetik & Modernität: ${img.aesthetics || '–'}/10`);
      lines.push(`Produktinszenierung: ${img.staging || '–'}/10`);
      if (img.comment) lines.push(`Kommentar: ${img.comment}`);
      lines.push('');
    });
    lines.push('=== Aufgabe 6 – Externe Inspiration ===');
    (answers.task4_examples || []).forEach((ex, i) => {
      lines.push(`Beispiel ${i + 1}: ${ex.url || '–'}`);
      lines.push(ex.why || '–');
      lines.push('');
    });
    lines.push('=== Aufgabe 7 – Marketingaktionen ===');
    lines.push(answers.task5_campaigns || '–');
    lines.push('');
    lines.push('=== Anhänge ===');
    if (Array.isArray(answers.attachmentNames) && answers.attachmentNames.length) {
      answers.attachmentNames.forEach((name) => lines.push(`- ${name}`));
      lines.push('');
      lines.push('Bilder liegen als E-Mail-Anhang bei (JPEG + HTML-Übersicht „Praxis-Check-Bilder.html“).');
    } else {
      lines.push('(keine)');
    }
    return lines.join('\n');
  }

  function showSuccessState() {
    if (els.gate) els.gate.hidden = true;
    if (els.app) els.app.hidden = true;
    if (els.success) els.success.hidden = false;
    root.scrollIntoView({ behavior: 'smooth', block: 'start' });
  }

  function safeFileName(name) {
    return String(name || 'bild.jpg')
      .replace(/[^\w.\-()+ äöüÄÖÜß]+/gi, '_')
      .slice(0, 80);
  }

  function loadImageFromFile(file) {
    return new Promise((resolve, reject) => {
      const url = URL.createObjectURL(file);
      const img = new Image();
      img.onload = () => {
        URL.revokeObjectURL(url);
        resolve(img);
      };
      img.onerror = () => {
        URL.revokeObjectURL(url);
        reject(new Error(`Bild „${file.name}“ konnte nicht geladen werden.`));
      };
      img.src = url;
    });
  }

  async function compressImageFile(file, prefix) {
    const baseName = safeFileName(`${prefix}_${file.name.replace(/\.[^.]+$/, '') || 'bild'}.jpg`);
    if (!file.type.startsWith('image/') || file.type === 'image/svg+xml') {
      return new File([file], safeFileName(`${prefix}_${file.name}`), {
        type: file.type || 'application/octet-stream',
        lastModified: file.lastModified,
      });
    }

    const img = await loadImageFromFile(file);
    const maxEdge = 1280;
    const scale = Math.min(1, maxEdge / Math.max(img.naturalWidth || img.width, img.naturalHeight || img.height));
    const width = Math.max(1, Math.round((img.naturalWidth || img.width) * scale));
    const height = Math.max(1, Math.round((img.naturalHeight || img.height) * scale));
    const canvas = document.createElement('canvas');
    canvas.width = width;
    canvas.height = height;
    const ctx = canvas.getContext('2d');
    if (!ctx) {
      return new File([file], safeFileName(`${prefix}_${file.name}`), {
        type: file.type || 'image/jpeg',
        lastModified: file.lastModified,
      });
    }
    ctx.drawImage(img, 0, 0, width, height);

    const blob = await new Promise((resolve) => {
      canvas.toBlob((result) => resolve(result), 'image/jpeg', 0.78);
    });
    if (!blob) {
      return new File([file], safeFileName(`${prefix}_${file.name}`), {
        type: file.type || 'image/jpeg',
        lastModified: file.lastModified,
      });
    }
    return new File([blob], baseName, { type: 'image/jpeg', lastModified: Date.now() });
  }

  async function collectAttachmentFiles() {
    /** @type {{file:File, uploadId:string, name:string}[]} */
    const prepared = [];
    const entries = [...uploads.entries()];
    for (const [uploadId, list] of entries) {
      for (let i = 0; i < list.length; i++) {
        const item = list[i];
        const prefix = `${uploadId}-${i + 1}`;
        const file = await compressImageFile(item.file, prefix);
        prepared.push({ file, uploadId, name: item.file.name });
      }
    }
    return prepared;
  }

  function fileToDataUrl(file) {
    return new Promise((resolve, reject) => {
      const reader = new FileReader();
      reader.onload = () => resolve(String(reader.result || ''));
      reader.onerror = () => reject(reader.error || new Error('Bild lesen fehlgeschlagen'));
      reader.readAsDataURL(file);
    });
  }

  async function buildImagesHtmlFile(answers, prepared) {
    const blocks = [];
    for (const item of prepared) {
      const dataUrl = await fileToDataUrl(item.file);
      blocks.push(
        `<section style="margin:0 0 28px">` +
          `<h2 style="font:600 16px/1.3 system-ui,sans-serif;margin:0 0 8px">[${escapeHtml(item.uploadId)}] ${escapeHtml(item.name)}</h2>` +
          `<img src="${dataUrl}" alt="${escapeHtml(item.name)}" style="max-width:100%;height:auto;border:1px solid #ddd"/>` +
          `</section>`
      );
    }

    const html =
      `<!DOCTYPE html><html lang="de"><head><meta charset="UTF-8">` +
      `<title>Praxis-Check Bilder – ${escapeHtml(answers.name || '')}</title></head>` +
      `<body style="font-family:system-ui,sans-serif;max-width:900px;margin:24px auto;padding:0 16px;color:#111">` +
      `<h1 style="font-size:22px">Praxis-Check Bilder</h1>` +
      `<p><strong>Name:</strong> ${escapeHtml(answers.name || '–')}<br>` +
      `<strong>E-Mail:</strong> ${escapeHtml(answers.email || '–')}</p>` +
      blocks.join('\n') +
      `</body></html>`;

    return new File([html], 'Praxis-Check-Bilder.html', {
      type: 'text/html',
      lastModified: Date.now(),
    });
  }

  function appendFileInput(form, name, file) {
    const input = document.createElement('input');
    input.type = 'file';
    input.name = name;
    const transfer = new DataTransfer();
    transfer.items.add(file);
    input.files = transfer.files;
    form.appendChild(input);
  }

  function markPendingSubmit() {
    try {
      sessionStorage.setItem(PENDING_KEY, '1');
      sessionStorage.setItem(UNLOCK_KEY, '1');
    } catch {
      /* ignore */
    }
  }

  function clearPendingSubmit() {
    try {
      sessionStorage.removeItem(PENDING_KEY);
    } catch {
      /* ignore */
    }
  }

  function wasPendingSubmit() {
    try {
      return sessionStorage.getItem(PENDING_KEY) === '1';
    } catch {
      return false;
    }
  }

  function formSubmitSentInUrl() {
    try {
      return new URLSearchParams(window.location.search).get('pc_sent') === '1';
    } catch {
      return false;
    }
  }

  function cleanSentUrl() {
    try {
      const url = new URL(window.location.href);
      if (!url.searchParams.has('pc_sent')) return;
      url.searchParams.delete('pc_sent');
      window.history.replaceState({}, '', url.pathname + url.search + url.hash);
    } catch {
      /* ignore */
    }
  }

  function appendHidden(form, name, value) {
    const input = document.createElement('input');
    input.type = 'hidden';
    input.name = name;
    input.value = value == null ? '' : String(value);
    form.appendChild(input);
  }

  async function submitViaWorker(answers) {
    if (!WORKER_URL) {
      throw new Error('Worker-URL fehlt (Theme-Editor → Praxis-Check).');
    }
    if (!SUBMIT_SECRET) {
      throw new Error('Submit-Secret fehlt (Theme-Editor → Praxis-Check).');
    }

    if (els.submitBtn) els.submitBtn.textContent = 'Bereite Bilder vor…';
    const prepared = await collectAttachmentFiles();
    const htmlFile = prepared.length ? await buildImagesHtmlFile(answers, prepared) : null;
    const totalBytes =
      prepared.reduce((sum, item) => sum + item.file.size, 0) + (htmlFile ? htmlFile.size : 0);
    if (totalBytes > MAX_SUBMIT_BYTES) {
      throw new Error(
        'Die Anhänge sind zusammen zu groß (max. ca. 9 MB). Bitte weniger oder kleinere Bilder wählen.'
      );
    }

    answers.attachmentNames = [
      ...prepared.map((item) => `[${item.uploadId}] ${item.name} → ${item.file.name}`),
      ...(htmlFile ? [htmlFile.name] : []),
    ];

    const body = new FormData();
    body.set('name', answers.name || '');
    body.set('email', answers.email || '');
    body.set('subject', `Praxis-Check Bewerbung: ${answers.name || ''}`.trim());
    body.set('message', buildMessageBody(answers));
    prepared.forEach((item, index) => {
      body.append(`file_${index + 1}`, item.file, item.file.name);
    });
    if (htmlFile) body.append('file_html', htmlFile, htmlFile.name);

    if (els.submitBtn) els.submitBtn.textContent = 'Sende Antworten…';
    const controller = new AbortController();
    const timer = setTimeout(() => controller.abort(), 60000);
    try {
      const res = await fetch(WORKER_URL, {
        method: 'POST',
        headers: {
          Accept: 'application/json',
          'X-PC-Secret': SUBMIT_SECRET,
        },
        body,
        signal: controller.signal,
      });
      const text = await res.text();
      let data = {};
      try {
        data = text ? JSON.parse(text) : {};
      } catch {
        data = { error: text };
      }
      if (!res.ok || !data.ok) {
        throw new Error(data.error || `Übermittlung fehlgeschlagen (${res.status}).`);
      }
      return true;
    } finally {
      clearTimeout(timer);
    }
  }

  async function onSubmit(event) {
    event.preventDefault();
    if (submitting) return;

    for (let i = 0; i < STEP_IDS.length; i++) {
      if (!validateStep(i)) {
        showStep(i, { validateCurrent: false });
        return;
      }
    }

    submitting = true;
    if (els.submitBtn) {
      els.submitBtn.disabled = true;
      els.submitBtn.textContent = 'Wird gesendet…';
    }
    hideToast();

    const answers = collectAnswers();
    persistForm();

    try {
      await submitViaWorker(answers);
      clearDraft();
      showSuccessState();
    } catch (err) {
      persistForm();
      const msg =
        err && err.name === 'AbortError'
          ? 'Zeitüberschreitung beim Senden. Bitte erneut versuchen.'
          : (err && err.message) ||
            'Übermittlung fehlgeschlagen. Deine Antworten wurden lokal gespeichert – bitte erneut versuchen.';
      showToast(msg);
      if (els.submitBtn) {
        els.submitBtn.disabled = false;
        els.submitBtn.textContent = 'Antworten absenden';
      }
      submitting = false;
    }
  }

  function openLightbox(src) {
    if (!src || !els.lightbox || !els.lightboxImg) return;
    els.lightboxImg.src = src;
    els.lightbox.hidden = false;
  }

  function closeLightbox() {
    if (!els.lightbox || !els.lightboxImg) return;
    els.lightbox.hidden = true;
    els.lightboxImg.removeAttribute('src');
  }

  function bindEvents() {
    if (els.passwordForm) els.passwordForm.addEventListener('submit', onPasswordSubmit);
    if (els.toastClose) els.toastClose.addEventListener('click', hideToast);
    if (els.form) {
      els.form.addEventListener('submit', onSubmit);
      els.form.addEventListener('input', (event) => {
        if (event.target && event.target.matches('[data-pc-slider]')) {
          const valueEl = event.target
            .closest('.praxis-check__slider-field')
            ?.querySelector('[data-pc-slider-value]');
          if (valueEl) valueEl.textContent = event.target.value;
        }
        persistForm();
        updateProgress();
      });
      els.form.addEventListener('change', () => {
        persistForm();
        updateProgress();
      });
      els.form.addEventListener('change', (event) => {
        const input = event.target.closest('[data-pc-file-input]');
        if (!input) return;
        const id = input.getAttribute('data-upload-id');
        if (!id) return;
        addFiles(id, input.files || []);
        input.value = '';
      });
    }
    if (els.prevBtn) {
      els.prevBtn.addEventListener('click', () => showStep(stepIndex - 1, { validateCurrent: false }));
    }
    if (els.nextBtn) {
      // Freie Navigation – Pflichtfelder erst beim Absenden prüfen
      els.nextBtn.addEventListener('click', () => showStep(stepIndex + 1, { validateCurrent: false }));
    }
    if (els.stepNav) {
      els.stepNav.addEventListener('click', (event) => {
        const btn = event.target.closest('[data-pc-goto]');
        if (!btn) return;
        const target = Number(btn.getAttribute('data-pc-goto'));
        if (Number.isNaN(target)) return;
        showStep(target, { validateCurrent: false });
      });
    }
    root.addEventListener('click', (event) => {
      const remove = event.target.closest('[data-pc-remove-file]');
      if (remove) {
        removeFile(remove.getAttribute('data-upload-id'), remove.getAttribute('data-file-id'));
        return;
      }
      const addAnswer = event.target.closest('[data-pc-add-answer]');
      if (addAnswer) {
        addAnswerBlock(addAnswer.getAttribute('data-pc-add-answer'));
        return;
      }
      const removeAnswer = event.target.closest('[data-pc-remove-answer]');
      if (removeAnswer) {
        const block = removeAnswer.closest('[data-pc-answer-block]');
        if (block) removeAnswerBlock(block);
        return;
      }
      const zoom = event.target.closest('[data-pc-zoom]');
      if (!zoom) return;
      const img = zoom.querySelector('img');
      openLightbox((img && img.currentSrc) || (img && img.src) || zoom.getAttribute('data-zoom-src'));
    });
    if (els.lightboxClose) els.lightboxClose.addEventListener('click', closeLightbox);
    if (els.lightbox) {
      els.lightbox.addEventListener('click', (event) => {
        if (event.target === els.lightbox) closeLightbox();
      });
    }
    document.addEventListener('keydown', (event) => {
      if (event.key === 'Escape') {
        closeLightbox();
        hideToast();
      }
    });
  }

  function init() {
    bindEvents();

    if (formSubmitSentInUrl()) {
      clearDraft();
      clearPendingSubmit();
      cleanSentUrl();
      showSuccessState();
      return;
    }

    // Zurück ohne Erfolgs-Flag (z. B. Abbruch): Entwurf behalten
    if (wasPendingSubmit()) {
      clearPendingSubmit();
    }

    let unlocked = false;
    try {
      unlocked = sessionStorage.getItem(UNLOCK_KEY) === '1';
    } catch {
      unlocked = false;
    }

    if (unlocked) {
      unlock();
    } else {
      els.gate.hidden = false;
      els.app.hidden = true;
      els.success.hidden = true;
    }
  }

  init();
})();
